import WidgetModel from '../widget-model'
import DatasetFilterWidgetView from './dataset-filter-widget-view'
import _ from 'lodash'

var DatasetFilterWidget = WidgetModel.extend({
	containerDefaults: {
		width: 400,
		height: 39
	},

	viewCls: DatasetFilterWidgetView,

	multiSettableProps: [ 'background', 'showFilterType' ],

	section: _.constant('datasets'),

	/**
	 * Gets or sets dataset filter property. Handles converting to/from JSON string
	 * (which is how widget properties are stored in the database)
	 * @param newFilter the new filter
	 * @param props any additional properties to set on this.properties
	 */
	filter: function (newFilter, props) {
		if (arguments.length === 0) {
			let filter = this.properties.get('filter')
			return filter ? JSON.parse(filter) : null
		}

		let allProps = _.extend({}, props, {
			filter: JSON.stringify(_.omit(newFilter, 'cid'))
		})

		this.properties.set(allProps)
	},

	operator: function (newOp) {
		let filter = this.filter()

		if (arguments.length === 0) {
			return filter ? filter.operator : null
		}

		filter.operator = newOp

		this.filter(filter)
	},

	datasetId () {
		return this.properties.get('datasetId')
	}
})

export default DatasetFilterWidget

DatasetFilterWidget.__filename__ = 'dashboards/widgets/dataset-filter/dataset-filter-widget-model.js'
